/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AdminProjectUserData
 */
export interface AdminProjectUserData {
    /**
     * 
     * @type {string}
     * @memberof AdminProjectUserData
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminProjectUserData
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminProjectUserData
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminProjectUserData
     */
    phone?: string;
    /**
     * 
     * @type {boolean}
     * @memberof AdminProjectUserData
     */
    isPrimaryContact?: boolean;
}

/**
 * Check if a given object implements the AdminProjectUserData interface.
 */
export function instanceOfAdminProjectUserData(value: object): value is AdminProjectUserData {
    return true;
}

export function AdminProjectUserDataFromJSON(json: any): AdminProjectUserData {
    return AdminProjectUserDataFromJSONTyped(json, false);
}

export function AdminProjectUserDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdminProjectUserData {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'email': json['email'] == null ? undefined : json['email'],
        'phone': json['phone'] == null ? undefined : json['phone'],
        'isPrimaryContact': json['isPrimaryContact'] == null ? undefined : json['isPrimaryContact'],
    };
}

export function AdminProjectUserDataToJSON(json: any): AdminProjectUserData {
    return AdminProjectUserDataToJSONTyped(json, false);
}

export function AdminProjectUserDataToJSONTyped(value?: AdminProjectUserData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'email': value['email'],
        'phone': value['phone'],
        'isPrimaryContact': value['isPrimaryContact'],
    };
}

